import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Loading from 'ui/atoms/Loading/Loading';
import AddLicenseForm from 'core/modules/components/forms/AddLicenseForm/AddLicenseForm';

import useDialogCode from './useDialogAddCode';

const DialogAddCode = ({ open, onClose, onSuccessRedeem }) => {
  const { onSubmit, setTitle, isLoading, errorLicense, errorMsg } = useDialogCode({ onSuccessRedeem, open });
  return (
    <Dialog title={setTitle()} isOpen={open} className={'dialog-add-license'} onClose={onClose} size="s">
      <div className="dialog-add-license__content">
        <AddLicenseForm onSubmit={onSubmit} error={errorLicense} errorMsg={errorMsg} />
      </div>
      {isLoading && <Loading />}
    </Dialog>
  );
};

DialogAddCode.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

DialogAddCode.defaultProps = {
  onClose: function () {},
  open: false,
};

export default DialogAddCode;
